<template>
	<nav aria-label="Page navigation example">
		<paginate
			v-model="data.current_page"
			:first-last-button="true"
			:page-count="data.last_page"
			:click-handler="changeUrl"
			prev-text="<span><i class='fas fa-caret-left'></i></span>"
			:prev-link-class="'page-link'"
			next-text="<span><i class='fas fa-caret-right'></i></span>"
			:next-link-class="'page-link'"
			:container-class="'pagination justify-content-center'"
			:page-class="'page-item'"
			:page-link-class="'page-link'">
		</paginate>
	</nav>
</template>

<style>
	.page-item.active .page-link {
	    z-index: 1;
	    color: #fff;
	    background-color: #f5982f;
	    border-color: #f5982f;
	}
</style>

<script>
import { EventBus } from '@/plugins/bus.js'
import Paginate from 'vuejs-paginate'

export default {
	name: 'Pagination',
	components: {
		Paginate
	},
	props: ['data'],
	methods: {
		changeUrl(page) {
			EventBus.$emit('changePage'+ this.$route.name, page)
		}
	}
}
</script>